import React, { Component } from "react";

class PrevSlider extends Component {
  state = {};
  render() {
    const { className, style, onClick } = this.props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          fontSize: "50px",
          left: "20px"
        }}
        onClick={onClick}
      ></div>
    );
  }
}

export default PrevSlider;
